import React, { createContext, useContext, ReactNode } from 'react'
import { useApiHeaders, type QueryParamHeaders } from '@/hooks/useQueryParams'

interface QueryParamsContextType {
  apiHeaders: QueryParamHeaders
}

const QueryParamsContext = createContext<QueryParamsContextType | undefined>(undefined)

interface QueryParamsProviderProps {
  children: ReactNode
}

export function QueryParamsProvider({ children }: QueryParamsProviderProps) {
  const apiHeaders = useApiHeaders()

  return (
    <QueryParamsContext.Provider value={{ apiHeaders }}>
      {children}
    </QueryParamsContext.Provider>
  )
}

export function useQueryParamsContext() {
  const context = useContext(QueryParamsContext)
  if (context === undefined) {
    throw new Error('useQueryParamsContext must be used within a QueryParamsProvider')
  }
  return context
} 